"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CtaButtonLayout = void 0;
var _components = require("@ori-ui/components");
var _editorialFetching = require("@ori/editorial-fetching");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _utils = require("../../utils");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const CtaButtonLayout = (param)=>{
    let { debug, modulePosition, banner, className, onClick } = param;
    const { modules, layout } = banner;
    const { getTestId } = (0, _testidGenerator.default)();
    const isBig = layout === _editorialFetching.EditorialBannerLayoutEnum.BigCtaButton;
    var _modules_;
    const { backgroundStorybookColor, link } = (_modules_ = modules === null || modules === void 0 ? void 0 : modules[0]) !== null && _modules_ !== void 0 ? _modules_ : {};
    const { title, relativeUrl } = link !== null && link !== void 0 ? link : {};
    const isPrimary = backgroundStorybookColor === _editorialFetching.StorybookColor.CommonBlack;
    if (!title || !relativeUrl) {
        return (0, _utils.getModulesContentError)({
            debug,
            layout,
            modulePosition
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Root, {
        className: className,
        "data-testid": getTestId(_constants.CTA_BUTTON_ROOT),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.Button, {
            variant: isPrimary ? 'contained' : 'outlined',
            color: isPrimary ? 'primary' : 'default',
            href: relativeUrl,
            minWidth: isBig ? 'min(330px, 100%)' : undefined,
            "data-testid": getTestId(_constants.CTA_BUTTON_BUTTON),
            onClick: onClick !== null && onClick !== void 0 ? onClick : undefined,
            children: title
        })
    });
};
exports.CtaButtonLayout = CtaButtonLayout;
